(() => {
  if (customElements.get('fp-discoveries')) return;
  class Discoveries extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      this._rail = this.querySelector('.fp-discoveries__rail');
      this._controls = this.querySelector('.fp-discoveries__controls');
      if (!this._rail || !this._controls) return;
      const signal = this._controller.signal;
      this._controls.hidden = false;
      this._prev = this.querySelector('[data-discoveries-direction="-1"]');
      this._next = this.querySelector('[data-discoveries-direction="1"]');
      this._controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-discoveries-direction]');
        if (!button || button.disabled || !this._rail.firstElementChild) return;
        const gap = parseFloat(getComputedStyle(this._rail).gap) || 0;
        const step = this._rail.firstElementChild.getBoundingClientRect().width + gap;
        const visible = Math.max(1, Math.round(this._rail.clientWidth / step));
        this._rail.scrollBy({left: Number(button.dataset.discoveriesDirection) * visible * step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal});
      this._rail.addEventListener('scroll', () => this.update(), {passive: true, signal});
      this._observer = new ResizeObserver(() => this.update());
      this._observer.observe(this._rail);
      this.update();
    }
    update() {
      if (!this._rail) return;
      const end = Math.max(0, this._rail.scrollWidth - this._rail.clientWidth);
      this._prev.disabled = this._rail.scrollLeft <= 2;
      this._next.disabled = this._rail.scrollLeft >= end - 2;
      this._controls.hidden = end < 2;
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._controller = null;
    }
  }
  customElements.define('fp-discoveries', Discoveries);
})();
